import { render, staticRenderFns } from "./site-setup-main.component.vue?vue&type=template&id=37aa2a62&scoped=true"
import script from "./site-setup-main.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-setup-main.component.vue?vue&type=style&index=0&id=37aa2a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa2a62",
  null
  
)

export default component.exports